// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateProductAttribute_cancelButton__BRjz4"};